export const certificatesMock = [
  {
    id: '78b47c63-a691-4d67-bbc6-403670753244',
    tag_uid: '29ca1d53-78f4-4aa5-8fa8-54a6a895e708',
    scan_counter: 0,
    status: 'active',
    meta: {
      show_provenance: true,
      show_scan_history: true,
    },
    description: null,
    created_at: '2025-10-28 22:23:59.902904',
    updated_at: '2025-10-29 23:07:13.569519',
    date_of_ownership: null,
    settings: {
      show_provenance: true,
      show_scan_history: true,
    },
    trigger_event: 'ADMIN_CREATE',
    timestamp: 1761897522091,
    company_id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
    public_url: '/api/certificates/common/78b47c63-a691-4d67-bbc6-403670753244',
    product: {
      id: 'c4f3ae4e-0bb7-42d9-8fa8-42049d81cfba',
      type: 'handbags',
      title: 'Chanel Classic Flap Medium',
      sku: 'CHANEL-CLASSIC-MED-CAVIAR',
      images: [
        'https://picsum.photos/id/160/1200/800',
        'https://picsum.photos/id/161/1200/800',
        'https://picsum.photos/id/162/1200/800',
        'https://picsum.photos/id/163/1200/800',
      ],
      description: 'Luxury leather craftsmanship, authenticated by Vera.',
      details: 'More info: https://vera.app/product/CHANEL-CLASSIC-MED-CAVIAR \nCare: handle with care.',
      quantity: 12,
      available: true,
      manufactured_at: null,
      integration_id: null,
      integration_provider: null,
      default_tag_id: null,
      slug: null,
      import_provider: null,
      import_metadata: null,
      created_at: '2025-10-28 22:23:59.869525',
      updated_at: null,
      deleted_at: null,
    },
    customer: {
      id: '888358cb-5926-461c-a86a-78ef8935e30d',
      company_id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
      first_name: 'John',
      last_name: 'Doe',
      username: null,
      birthday: null,
      avatar: null,
      phone: 'string',
      email: 'example@gmail.com',
      active: true,
      gender: null,
      country: null,
      created_at: '2025-10-28 22:23:59.843641',
      updated_at: '2025-10-28 22:25:45.59',
      is_deleted: false,
      deleted_at: null,
      deleted_by: null,
      shopify_customer_id: null,
      integration_source: 'MANUAL',
      integration_metadata: null,
      last_synced_at: null,
    },
    company: {
      id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
      provider: null,
      name: 'Louis Vuitton',
      logo: 'Louis Vuitton Logo',
      created_at: '2025-10-28 22:23:59.814998',
      updated_at: null,
      stripe_customer_id: null,
      shopify_customer_id: null,
      workos_org_id: null,
      workos_invitation_id: null,
      workos_admin_invited_at: null,
      workos_admin_accepted_at: null,
      embedd_key: null,
    },
    transfer: {
      id: 'd08d746c-bb23-4ef5-b887-80cac3fca07a',
      type: 'customer',
      status: 'initiated',
      from_admin_id: null,
      price: 999999.99,
      currency: 'brl',
      code: '7033',
      metadata: null,
      created_at: '2025-10-29 16:48:49.156',
      updated_at: '2025-10-29 16:48:49.156',
      expire_at: '2025-10-30T19:48:49.156Z',
      fromCustomer: {
        id: '888358cb-5926-461c-a86a-78ef8935e30d',
        company_id: null,
        first_name: 'John',
        last_name: 'Doe',
        username: null,
        birthday: null,
        avatar: null,
        phone: 'string',
        email: 'example@gmail.com',
        active: true,
        gender: null,
        country: null,
        created_at: '2025-10-28 22:23:59.843641',
        updated_at: '2025-10-28 22:25:45.59',
        is_deleted: false,
        deleted_at: null,
        deleted_by: null,
        shopify_customer_id: null,
        integration_source: 'MANUAL',
        integration_metadata: null,
        last_synced_at: null,
      },
      toCustomer: {
        id: '0381d990-89aa-4946-9960-f81cc1aa208a',
        company_id: null,
        first_name: 'Jane',
        last_name: 'Smith',
        username: null,
        birthday: null,
        avatar: null,
        phone: 'string',
        email: 'jane@gmail.com',
        active: true,
        gender: null,
        country: null,
        created_at: '2025-10-28 22:23:59.846342',
        updated_at: '2025-10-28 22:26:41.31',
        is_deleted: false,
        deleted_at: null,
        deleted_by: null,
        shopify_customer_id: null,
        integration_source: 'MANUAL',
        integration_metadata: null,
        last_synced_at: null,
      },
    },
    last_scan: {
      id: 'b0000000-0000-0000-0000-000000000017',
      type: 'scan',
      snapshot: {
        status: 'active',
      },
      metadata: {
        ip: '192.168.3.3',
        city: 'Munich',
        country: 'Germany',
        latitude: 48.1351,
        location: 'Münich, Germany',
        longitude: 11.582,
        user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64)',
      },
      user_type: 'customer',
      user_id: '888358cb-5926-461c-a86a-78ef8935e30d',
      created_at: '2024-07-08 09:15:00',
    },
    has_invalid_scans: false,
  },
  {
    id: 'ba34f9f9-4158-4268-bbd9-4aa3873967d9',
    tag_uid: '63d81bc0-ab4d-427e-988b-5d307344bcf8',
    scan_counter: 0,
    status: 'lost',
    meta: {
      show_provenance: true,
      show_scan_history: true,
    },
    description: null,
    created_at: '2025-10-28 22:23:59.906163',
    updated_at: '2025-10-28 22:23:59.906163',
    date_of_ownership: null,
    settings: {
      show_provenance: true,
      show_scan_history: true,
    },
    trigger_event: 'ADMIN_CREATE',
    timestamp: 1761897522091,
    company_id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
    public_url: '/api/certificates/common/ba34f9f9-4158-4268-bbd9-4aa3873967d9',
    product: {
      id: 'a03bf306-f387-4b44-8fcf-ed84a63d09bd',
      type: 'watches',
      title: 'Audemars Piguet Royal Oak',
      sku: 'AP-ROYALOAK-15510ST',
      images: [
        'https://picsum.photos/id/151/1200/800',
        'https://picsum.photos/id/152/1200/800',
        'https://picsum.photos/id/153/1200/800',
      ],
      description: 'High-precision timepiece with certified provenance.',
      details: 'More info: https://vera.app/product/AP-ROYALOAK-15510ST \nCare: handle with care.',
      quantity: 8,
      available: true,
      manufactured_at: null,
      integration_id: null,
      integration_provider: null,
      default_tag_id: null,
      slug: null,
      import_provider: null,
      import_metadata: null,
      created_at: '2025-10-28 22:23:59.866985',
      updated_at: null,
      deleted_at: null,
    },
    customer: {
      id: '888358cb-5926-461c-a86a-78ef8935e30d',
      company_id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
      first_name: 'John',
      last_name: 'Doe',
      username: null,
      birthday: null,
      avatar: null,
      phone: 'string',
      email: 'example@gmail.com',
      active: true,
      gender: null,
      country: null,
      created_at: '2025-10-28 22:23:59.843641',
      updated_at: '2025-10-28 22:25:45.59',
      is_deleted: false,
      deleted_at: null,
      deleted_by: null,
      shopify_customer_id: null,
      integration_source: 'MANUAL',
      integration_metadata: null,
      last_synced_at: null,
    },
    company: {
      id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
      provider: null,
      name: 'Louis Vuitton',
      logo: 'Louis Vuitton Logo',
      created_at: '2025-10-28 22:23:59.814998',
      updated_at: null,
      stripe_customer_id: null,
      shopify_customer_id: null,
      workos_org_id: null,
      workos_invitation_id: null,
      workos_admin_invited_at: null,
      workos_admin_accepted_at: null,
      embedd_key: null,
    },
    last_scan: {
      id: 'b0000000-0000-0000-0000-000000000011',
      type: 'scan',
      snapshot: {
        status: 'active',
        public_url: 'https://vera.app/certificate/ba34f9f9-4158-4268-bbd9-4aa3873967d9',
      },
      metadata: {
        ip: '192.168.1.11',
        city: 'Tokyo',
        country: 'Japan',
        latitude: 35.6762,
        location: 'Tokyo, Japan',
        longitude: 139.6503,
        user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64)',
      },
      user_type: 'anonymous',
      user_id: null,
      created_at: '2024-12-01 16:00:00',
    },
    has_invalid_scans: false,
  },
  {
    id: '781b5f7f-85a8-4664-8f6e-3a5d4f66fb02',
    tag_uid: '8bb60a66-c77b-468b-8ab7-ef1e03ea0813',
    scan_counter: 0,
    status: 'stolen',
    meta: {
      show_provenance: true,
      show_scan_history: true,
    },
    description: null,
    created_at: '2025-10-28 22:23:59.899305',
    updated_at: '2025-10-28 22:23:59.899305',
    date_of_ownership: null,
    settings: {
      show_provenance: true,
      show_scan_history: true,
    },
    trigger_event: 'ADMIN_CREATE',
    timestamp: 1761897522091,
    company_id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
    public_url: '/api/certificates/common/781b5f7f-85a8-4664-8f6e-3a5d4f66fb02',
    product: {
      id: '0381d990-89aa-4946-9960-f81cc1aa208a',
      type: 'watches',
      title: 'Omega Speedmaster Moonwatch',
      sku: 'OMEGA-SPEED-310.30.42.50.01.001',
      images: ['https://picsum.photos/id/101/1200/800'],
      description: 'High-precision timepiece with certified provenance.',
      details: 'More info: https://vera.app/product/OMEGA-SPEED-310.30.42.50.01.001 \nCare: handle with care.',
      quantity: 25,
      available: true,
      manufactured_at: null,
      integration_id: null,
      integration_provider: null,
      default_tag_id: null,
      slug: null,
      import_provider: null,
      import_metadata: null,
      created_at: '2025-10-28 22:23:59.850117',
      updated_at: null,
      deleted_at: null,
    },
    customer: {
      id: '888358cb-5926-461c-a86a-78ef8935e30d',
      company_id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
      first_name: 'John',
      last_name: 'Doe',
      username: null,
      birthday: null,
      avatar: null,
      phone: 'string',
      email: 'example@gmail.com',
      active: true,
      gender: null,
      country: null,
      created_at: '2025-10-28 22:23:59.843641',
      updated_at: '2025-10-28 22:25:45.59',
      is_deleted: false,
      deleted_at: null,
      deleted_by: null,
      shopify_customer_id: null,
      integration_source: 'MANUAL',
      integration_metadata: null,
      last_synced_at: null,
    },
    company: {
      id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
      provider: null,
      name: 'Louis Vuitton',
      logo: 'Louis Vuitton Logo',
      created_at: '2025-10-28 22:23:59.814998',
      updated_at: null,
      stripe_customer_id: null,
      shopify_customer_id: null,
      workos_org_id: null,
      workos_invitation_id: null,
      workos_admin_invited_at: null,
      workos_admin_accepted_at: null,
      embedd_key: null,
    },
    has_invalid_scans: false,
  },
  {
    id: '4729d4ea-b88b-4877-b071-c492ed4a9646',
    tag_uid: '7e1c0640-8eb9-403b-9173-3569b5e9a4e9',
    scan_counter: 0,
    status: 'stolen',
    meta: {
      show_provenance: true,
      show_scan_history: true,
    },
    description: null,
    created_at: '2025-10-28 22:23:59.895717',
    updated_at: '2025-10-28 22:23:59.895717',
    date_of_ownership: null,
    settings: {
      show_provenance: true,
      show_scan_history: true,
    },
    trigger_event: 'ADMIN_CREATE',
    timestamp: 1761897522092,
    company_id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
    public_url: '/api/certificates/common/4729d4ea-b88b-4877-b071-c492ed4a9646',
    product: {
      id: 'd1206f20-ab5e-49be-a4a7-73afec30e4b0',
      type: 'jewelry',
      title: 'Cartier Love Bracelet Yellow Gold',
      sku: 'CARTIER-LOVE-BRACELET-YG',
      images: ['https://picsum.photos/id/170/1200/800'],
      description: 'Premium item with authenticity certificate.',
      details: 'More info: https://vera.app/product/CARTIER-LOVE-BRACELET-YG \nCare: handle with care.',
      quantity: 30,
      available: true,
      manufactured_at: null,
      integration_id: null,
      integration_provider: null,
      default_tag_id: null,
      slug: null,
      import_provider: null,
      import_metadata: null,
      created_at: '2025-10-28 22:23:59.872648',
      updated_at: null,
      deleted_at: null,
    },
    customer: {
      id: '888358cb-5926-461c-a86a-78ef8935e30d',
      company_id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
      first_name: 'John',
      last_name: 'Doe',
      username: null,
      birthday: null,
      avatar: null,
      phone: 'string',
      email: 'example@gmail.com',
      active: true,
      gender: null,
      country: null,
      created_at: '2025-10-28 22:23:59.843641',
      updated_at: '2025-10-28 22:25:45.59',
      is_deleted: false,
      deleted_at: null,
      deleted_by: null,
      shopify_customer_id: null,
      integration_source: 'MANUAL',
      integration_metadata: null,
      last_synced_at: null,
    },
    company: {
      id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
      provider: null,
      name: 'Louis Vuitton',
      logo: 'Louis Vuitton Logo',
      created_at: '2025-10-28 22:23:59.814998',
      updated_at: null,
      stripe_customer_id: null,
      shopify_customer_id: null,
      workos_org_id: null,
      workos_invitation_id: null,
      workos_admin_invited_at: null,
      workos_admin_accepted_at: null,
      embedd_key: null,
    },
    has_invalid_scans: false,
  },
  {
    id: '3408316f-67df-4e9e-96e1-c691ce2f07e3',
    tag_uid: '6768d6d0-d147-4502-a6cf-64ed57a31748',
    scan_counter: 0,
    status: 'lost',
    meta: {
      show_provenance: true,
      show_scan_history: true,
    },
    description: null,
    created_at: '2025-10-28 22:23:59.892136',
    updated_at: '2025-10-28 22:23:59.892136',
    date_of_ownership: null,
    settings: {
      show_provenance: true,
      show_scan_history: true,
    },
    trigger_event: 'ADMIN_CREATE',
    timestamp: 1761897522092,
    company_id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
    public_url: '/api/certificates/common/3408316f-67df-4e9e-96e1-c691ce2f07e3',
    product: {
      id: '1a483ae7-e24b-46f3-8742-7cdd66ccecca',
      type: 'apparel',
      title: 'Louis Vuitton Monogram Jacket',
      sku: 'LV-JACKET-MONO-2023',
      images: [
        'https://picsum.photos/id/110/1200/800',
        'https://picsum.photos/id/111/1200/800',
        'https://picsum.photos/id/112/1200/800',
      ],
      description: 'Premium item with authenticity certificate.',
      details: 'More info: https://vera.app/product/LV-JACKET-MONO-2023 \nCare: handle with care.',
      quantity: 40,
      available: true,
      manufactured_at: null,
      integration_id: null,
      integration_provider: null,
      default_tag_id: null,
      slug: null,
      import_provider: null,
      import_metadata: null,
      created_at: '2025-10-28 22:23:59.853644',
      updated_at: null,
      deleted_at: null,
    },
    customer: {
      id: '888358cb-5926-461c-a86a-78ef8935e30d',
      company_id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
      first_name: 'John',
      last_name: 'Doe',
      username: null,
      birthday: null,
      avatar: null,
      phone: 'string',
      email: 'example@gmail.com',
      active: true,
      gender: null,
      country: null,
      created_at: '2025-10-28 22:23:59.843641',
      updated_at: '2025-10-28 22:25:45.59',
      is_deleted: false,
      deleted_at: null,
      deleted_by: null,
      shopify_customer_id: null,
      integration_source: 'MANUAL',
      integration_metadata: null,
      last_synced_at: null,
    },
    company: {
      id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
      provider: null,
      name: 'Louis Vuitton',
      logo: 'Louis Vuitton Logo',
      created_at: '2025-10-28 22:23:59.814998',
      updated_at: null,
      stripe_customer_id: null,
      shopify_customer_id: null,
      workos_org_id: null,
      workos_invitation_id: null,
      workos_admin_invited_at: null,
      workos_admin_accepted_at: null,
      embedd_key: null,
    },
    has_invalid_scans: false,
  },
  {
    id: '0cbcef57-b813-4a34-8471-70df7fc1d925',
    tag_uid: '1aefd528-745a-4ed5-a279-d10638d1a095',
    scan_counter: 0,
    status: 'active',
    meta: {
      show_provenance: true,
      show_scan_history: true,
    },
    description: null,
    created_at: '2025-10-28 22:23:59.883393',
    updated_at: '2025-10-28 22:23:59.883393',
    date_of_ownership: null,
    settings: {
      show_provenance: true,
      show_scan_history: true,
    },
    trigger_event: 'ADMIN_CREATE',
    timestamp: 1761897522092,
    company_id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
    public_url: '/api/certificates/common/0cbcef57-b813-4a34-8471-70df7fc1d925',
    product: {
      id: '25020771-d9db-417a-b4d6-eba69252e8a6',
      type: 'watches',
      title: 'Rolex Submariner Date',
      sku: 'ROLEX-126610LN',
      images: [
        'https://picsum.photos/id/120/1200/800',
        'https://picsum.photos/id/121/1200/800',
        'https://picsum.photos/id/122/1200/800',
        'https://picsum.photos/id/123/1200/800',
      ],
      description: 'High-precision timepiece with certified provenance.',
      details: 'More info: https://vera.app/product/ROLEX-126610LN \nCare: handle with care.',
      quantity: 10,
      available: true,
      manufactured_at: null,
      integration_id: null,
      integration_provider: null,
      default_tag_id: null,
      slug: null,
      import_provider: null,
      import_metadata: null,
      created_at: '2025-10-28 22:23:59.856544',
      updated_at: null,
      deleted_at: null,
    },
    customer: {
      id: '888358cb-5926-461c-a86a-78ef8935e30d',
      company_id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
      first_name: 'John',
      last_name: 'Doe',
      username: null,
      birthday: null,
      avatar: null,
      phone: 'string',
      email: 'example@gmail.com',
      active: true,
      gender: null,
      country: null,
      created_at: '2025-10-28 22:23:59.843641',
      updated_at: '2025-10-28 22:25:45.59',
      is_deleted: false,
      deleted_at: null,
      deleted_by: null,
      shopify_customer_id: null,
      integration_source: 'MANUAL',
      integration_metadata: null,
      last_synced_at: null,
    },
    company: {
      id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
      provider: null,
      name: 'Louis Vuitton',
      logo: 'Louis Vuitton Logo',
      created_at: '2025-10-28 22:23:59.814998',
      updated_at: null,
      stripe_customer_id: null,
      shopify_customer_id: null,
      workos_org_id: null,
      workos_invitation_id: null,
      workos_admin_invited_at: null,
      workos_admin_accepted_at: null,
      embedd_key: null,
    },
    transfer: {
      id: 'c5d6e7f8-7890-1234-abcd-567890123456',
      type: 'store',
      status: 'initiated',
      from_admin_id: null,
      price: null,
      currency: null,
      code: 'TRANSFER_002',
      metadata: null,
      created_at: '2025-10-28 22:24:00.045264',
      updated_at: '2025-10-31T07:58:42.092Z',
      expire_at: '2025-11-01T07:58:42.092Z',
      fromCustomer: null,
      toCustomer: {
        id: '888358cb-5926-461c-a86a-78ef8935e30d',
        company_id: null,
        first_name: 'John',
        last_name: 'Doe',
        username: null,
        birthday: null,
        avatar: null,
        phone: 'string',
        email: 'example@gmail.com',
        active: true,
        gender: null,
        country: null,
        created_at: '2025-10-28 22:23:59.843641',
        updated_at: '2025-10-28 22:25:45.59',
        is_deleted: false,
        deleted_at: null,
        deleted_by: null,
        shopify_customer_id: null,
        integration_source: 'MANUAL',
        integration_metadata: null,
        last_synced_at: null,
      },
    },
    last_scan: {
      id: 'e5f6a7b8-7890-1234-abcd-567890123456',
      type: 'scan',
      snapshot: {
        status: 'active',
        scan_count: 1,
      },
      metadata: null,
      user_type: 'customer',
      user_id: '888358cb-5926-461c-a86a-78ef8935e30d',
      created_at: '2025-10-28 22:23:59.977483',
    },
    has_invalid_scans: false,
  },
  {
    id: '009027a3-f078-46e9-8018-eab3320413d6',
    tag_uid: '6634f78d-7906-4de7-874d-0aeae0a058cd',
    scan_counter: 0,
    status: 'active',
    meta: {
      show_provenance: true,
      show_scan_history: true,
    },
    description: null,
    created_at: '2025-10-28 22:23:59.880889',
    updated_at: '2025-10-28 22:23:59.880889',
    date_of_ownership: null,
    settings: {
      show_provenance: true,
      show_scan_history: true,
    },
    trigger_event: 'ADMIN_CREATE',
    timestamp: 1761897522092,
    company_id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
    public_url: '/api/certificates/common/009027a3-f078-46e9-8018-eab3320413d6',
    product: {
      id: '4db8c67a-cc98-4b95-8d38-cdab768ed393',
      type: 'eyewear',
      title: 'Ray-Ban Wayfarer Classic',
      sku: 'RAYBAN-WAYFARER-RB2140',
      images: ['https://picsum.photos/id/140/1200/800'],
      description: 'Iconic eyewear with verified materials.',
      details: 'More info: https://vera.app/product/RAYBAN-WAYFARER-RB2140 \nCare: handle with care.',
      quantity: 120,
      available: true,
      manufactured_at: null,
      integration_id: null,
      integration_provider: null,
      default_tag_id: null,
      slug: null,
      import_provider: null,
      import_metadata: null,
      created_at: '2025-10-28 22:23:59.863614',
      updated_at: null,
      deleted_at: null,
    },
    customer: {
      id: '888358cb-5926-461c-a86a-78ef8935e30d',
      company_id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
      first_name: 'John',
      last_name: 'Doe',
      username: null,
      birthday: null,
      avatar: null,
      phone: 'string',
      email: 'example@gmail.com',
      active: true,
      gender: null,
      country: null,
      created_at: '2025-10-28 22:23:59.843641',
      updated_at: '2025-10-28 22:25:45.59',
      is_deleted: false,
      deleted_at: null,
      deleted_by: null,
      shopify_customer_id: null,
      integration_source: 'MANUAL',
      integration_metadata: null,
      last_synced_at: null,
    },
    company: {
      id: 'f0d79e0e-3ff9-4d44-aa98-6609fd264cd7',
      provider: null,
      name: 'Louis Vuitton',
      logo: 'Louis Vuitton Logo',
      created_at: '2025-10-28 22:23:59.814998',
      updated_at: null,
      stripe_customer_id: null,
      shopify_customer_id: null,
      workos_org_id: null,
      workos_invitation_id: null,
      workos_admin_invited_at: null,
      workos_admin_accepted_at: null,
      embedd_key: null,
    },
    transfer: {
      id: 'b4c5d6e7-7890-1234-abcd-456789012345',
      type: 'customer',
      status: 'success',
      from_admin_id: null,
      price: 100,
      currency: 'USD',
      code: 'TRANSFER_001',
      metadata: null,
      created_at: '2025-10-28 22:24:00.041511',
      updated_at: '2025-10-31T07:58:42.092Z',
      expire_at: null,
      fromCustomer: null,
      toCustomer: {
        id: '888358cb-5926-461c-a86a-78ef8935e30d',
        company_id: null,
        first_name: 'John',
        last_name: 'Doe',
        username: null,
        birthday: null,
        avatar: null,
        phone: 'string',
        email: 'example@gmail.com',
        active: true,
        gender: null,
        country: null,
        created_at: '2025-10-28 22:23:59.843641',
        updated_at: '2025-10-28 22:25:45.59',
        is_deleted: false,
        deleted_at: null,
        deleted_by: null,
        shopify_customer_id: null,
        integration_source: 'MANUAL',
        integration_metadata: null,
        last_synced_at: null,
      },
    },
    last_scan: {
      id: 'b0000000-0000-0000-0000-000000000016',
      type: 'scan',
      snapshot: {
        status: 'active',
      },
      metadata: {
        ip: '192.168.3.2',
        city: 'Barcelona',
        country: 'Spain',
        latitude: 41.3874,
        location: 'Barcelona, Spain',
        longitude: 2.1686,
        user_agent: 'Mozilla/5.0 (Android 13; Mobile)',
      },
      user_type: 'customer',
      user_id: '0381d990-89aa-4946-9960-f81cc1aa208a',
      created_at: '2024-04-12 18:30:00',
    },
    has_invalid_scans: false,
  },
];
